module.exports = __webpack_public_path__ + "img/Binosto-logo-dark.7d500481.svg";